function parseTimeValue(value) {
  const trimmed = value.trim();

  if (trimmed.endsWith('ms')) {
    return parseFloat(trimmed);
  }

  if (trimmed.endsWith('s')) {
    return parseFloat(trimmed) * 1000;
  }

  return 0;
}

function getMaxTransitionEndTime(element) {
  const style = element.ownerDocument.defaultView.getComputedStyle(element);
  const durations = style.transitionDuration.split(',').map(parseTimeValue);
  const delays = style.transitionDelay.split(',').map(parseTimeValue);

  if (durations.length === 0) {
    return 0;
  }

  return Math.max(...durations.map((duration, index) => duration + (delays[index % delays.length] || 0)));
}

function waitForTransitionEnd(element, callback) {
  const maxTransitionEndTime = getMaxTransitionEndTime(element);

  if (maxTransitionEndTime === 0) {
    callback();
    return;
  }

  let triggered = false;
  let debounceTimer = null;

  const clearTimers = () => {
    clearTimeout(debounceTimer);
  };

  const trigger = () => {
    if (triggered) return;

    triggered = true;
    clearTimers();
    element.removeEventListener('transitionend', onTransitionEnd);
    callback();
  };

  const onTransitionEnd = () => {
    clearTimers();
    debounceTimer = setTimeout(trigger, 50);
  };

  element.addEventListener('transitionend', onTransitionEnd);
  debounceTimer = setTimeout(trigger, maxTransitionEndTime + 100);
}

export const scrollToTargetElement = (id) => {
  try {
    const iframe = document.getElementById('psn-widget-content-frame');

    if (!iframe) {
      const targetElement = document.getElementById(`component-${id}`);

      if (targetElement) {
        waitForTransitionEnd(targetElement, () => {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }

      return;
    }

    const pisanoContainer = iframe.contentWindow.document.getElementById('pisano-container');
    if (!pisanoContainer) return;

    const targetElement = pisanoContainer.querySelector(`[id='component-${id}']`);

    if (targetElement) {
      waitForTransitionEnd(targetElement, () => {
        try {
          // find header height because maybe it's changed
          const header = iframe.contentWindow.document.querySelector(
            '#pisano-frame-root .widget-content-container .widget-content-container__header',
          );
          const offset = targetElement.offsetTop - (header ? header.offsetHeight : 0) - 20;
          pisanoContainer.scrollTo({ top: offset, behavior: 'smooth' });
        } catch (e) {
          console.error('scrollToTargetElement', e);
          // targetElement.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        }
      });
    }
  } catch (e) {
    console.error('scrollToTargetElement', e);
  }
};
